import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, API_URL } from "../../../config/api";
import axiosService from "../../../services/axiosServicesVisit";

const persons_api_base_url = `${API_URL}${API.API_PREFIX || '/api'}${API.VERSION || '/v1'}${API.PERSONS?.BASE || "/persons"}`;

export const uploadOthersFile = createAsyncThunk(
  'upload/pharmacyFile', 
  async (formData, { rejectWithValue }) => {
    try {
      const api_url = `${persons_api_base_url}/import/pharmacies?format=csv`;
      const response = await axiosService.post(api_url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Une erreur inconnue est survenue." });
    }
  }
);

export const uploadWholesalerFile = createAsyncThunk(
  'upload/wholesalerFile', 
  async (formData, { rejectWithValue }) => {
    try {
      const api_url = `${persons_api_base_url}/import/wholesalers?format=csv`;
      const response = await axiosService.post(api_url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', 
        },
      });
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Une erreur inconnue est survenue." });
    }
  }
);